import API from "../helpers/api";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { checkUser } from "helpers/Session";

const Aspek = () => {
	const [aspeks, setAspeks] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!loading) return;
		(async () => {
			await API.get("/aspek")
				.then((res) => {
					setAspeks(Array.isArray(res.data.data) ? res.data.data : []);
				})
				.catch((err) => {
					Swal.fire({
						icon: "error",
						title: "Terjadi kesalahan",
						text: "Silahkan hubungi PIT!",
						footer: "Error: " + err.message,
					});
				})
				.finally(() => setLoading(false));
		})();
	}, [loading]);

	return (
		<>
			{!checkUser() ? (
				<Redirect to={"/"} />
			) : (
				<>
					<div className="bg-primary-light px-3 md:px-8 h-40" />

					<div className="px-3 md:px-8 h-auto -mt-36">
						<div className="container mx-auto max-w-full min-h-screen">
							<div className="grid grid-cols-1 px-4 mb-16">
								<div className="glass-card flex flex-col min-w-0 break-words bg-white w-full shadow-soft rounded-2xl">
									<div className="p-6">
										<div className="overflow-x-auto overflow-y-auto max-h-screen">
											<table className="items-center w-full border-collapse">
												<thead>
													<tr>
														<th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
															No
														</th>
														<th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
															Jabatan
														</th>
														<th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
															Aspek
														</th>
														<th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
															Sub Aspek
														</th>
													</tr>
												</thead>
												<tbody>
													{!loading ? (
														aspeks.length > 0 ? aspeks.map((item, index) => {
															const subAspek = Array.isArray(item.sub_aspek)
																? item.sub_aspek
																: [];
															return (
																<tr key={index}>
																	<td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
																		{index + 1}
																	</td>
																	<td className="border-b border-gray-200 align-middle font-light text-sm px-2 py-4 text-left">
																		<div className="w-28">
																			{item.jabatan?.jabatan || "-"}
																		</div>
																	</td>
																	<td className="border-b border-gray-200 align-middle font-light text-sm px-2 py-4 text-left">
																		<div className="w-28">{item.aspek || "-"}</div>
																	</td>
																	<td className="border-b border-gray-200 align-middle font-light text-sm px-2 py-4 text-left">
																		<div className="break-word overflow-y-auto">
																			{subAspek.length > 0 ? subAspek.map((item, index) => {
																				return (
																					<div className="my-3" key={index}>
																						<p className="font-semibold">
																							{item.sub_aspek || "-"}
																						</p>
																						<p className="font-normal">
																							{item.deskripsi || "-"}
																						</p>
																					</div>
																				);
																			}) : <p>-</p>}
																		</div>
																	</td>
																</tr>
															);
														}) : (
															<tr>
																<td
																	colSpan={4}
																	className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-center"
																>
																	Tidak Ada Data
																</td>
															</tr>
														)
													) : (
														<tr>
															<td
																colSpan={5}
																className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-center animate-pulse"
															>
																Memuat Data...
															</td>
														</tr>
													)}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default Aspek;
